module.exports = __webpack_public_path__ + "assets/trashcan.2d43b0da.svg";